import PropTypes from 'prop-types';
import React from 'react';

export class Paginator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inputPageNumber: 1,
    }
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.currentPageNumber != this.state.inputPageNumber) {
      this.setState({ inputPageNumber: nextProps.currentPageNumber });
    }
  }

  onChange = (e) => {
    this.setState({ inputPageNumber: e.target.value });
  }

  onClickPrev = () => {
    if (!(this.props.currentPageNumber <= 1)) {
      this.setState({ inputPageNumber: this.state.inputPageNumber - 1 });
      this.props.onPageChange(this.props.currentPageNumber - 1);
    }
  }

  onClickNext = () => {
    if (!(this.props.currentPageNumber >= this.props.totalNumberOfPages)) {
      this.setState({ inputPageNumber: this.state.inputPageNumber + 1 });
      this.props.onPageChange(this.props.currentPageNumber + 1);
    }
  }

  onKeyPress = (e) => {
    if (e.key === 'Enter') {
      const value = e.target.value;
      if (!isNaN(value) && value >= 1 && value <= this.props.totalNumberOfPages) {
        this.setState({ inputPageNumber: value });
        this.props.onPageChange(parseInt(value, 10));
      } else {
        this.setState({ inputPageNumber: this.props.currentPageNumber });
      }
    }
  }

  render() {
    const { currentPageNumber, totalNumberOfPages } = this.props;
    return (
      <div className="multi-page-nav">
        <div className="float-end">
            <button type="button"
              className="btn btn-link theme"
              onClick={ this.onClickPrev }
              disabled={ currentPageNumber <= 1}
            >
              <span className="fa-solid fa-chevron-left" />
            </button>
            <div className="page-number d-none d-sm-inline mx-2 mt-2 align-middle">
              <input className="selected-page"
                type="text"
                value={ this.state.inputPageNumber }
                onChange={ this.onChange }
                onKeyPress={ this.onKeyPress }
              />
              {' / {0}'.replace('{0}', totalNumberOfPages)}
            </div>
            <button type="button"
              className="btn btn-link theme"
              onClick={ this.onClickNext }
              disabled={ currentPageNumber >= totalNumberOfPages }
            >
              <span className="fa-solid fa-chevron-right" />
            </button>
        </div>
      </div>
    );
  }
}

Paginator.propTypes = {
  currentPageNumber: PropTypes.number,
  totalNumberOfPages: PropTypes.number,
  onPageChange: PropTypes.func,
};